// extracted by mini-css-extract-plugin
export default {"menu-list":"ProfileMenu_menu-list__ldi2g","active":"ProfileMenu_active__TBMlE","link":"ProfileMenu_link__FnZTi","social-links":"ProfileMenu_social-links__cuIyW"};